import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { LoginForm } from "./LoginForm";
import { useNavigate } from "react-router-dom";
import { authenticate, getEmbedToken } from "../../utils/auth";
import useAuthStore from "../../utils/authStore";

export const LoginPage = () => {
  const setAccessToken = useAuthStore((state) => state.setAccessToken);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (username, password) => {
    try {
      setIsLoading(true);
      const data = await authenticate(username, password);
      setAccessToken(data?.access_token);

      const embedTokenRes = await getEmbedToken(data?.access_token);

      const expireAt = new Date(Date.now() + 15 * 60 * 1000).toISOString();
      useAuthStore.setState({
        embedToken: { token: embedTokenRes, expireAt },
      });

      navigate("/");
      setError("");
    } catch (err) {
      setError("Invalid username or password");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        bgcolor: "grey.100",
      }}
    >
      <Container maxWidth="sm">
        <LoginForm onLogin={handleLogin} error={error} isLoading={isLoading} />
      </Container>
    </Box>
  );
};
